/**
 * 工作流步骤失败后的处理策略（模板中每个节点独立配置）。
 * 与后端 WorkflowTaskExecutionSupport.resolveStepFailurePolicy 的取值保持一致。
 */
export const STEP_FAILURE_POLICY_ABORT = 'abort';
export const STEP_FAILURE_POLICY_SKIP = 'skip';

export const STEP_FAILURE_POLICY_OPTIONS = [
  {
    value: STEP_FAILURE_POLICY_ABORT,
    label: '终止整批',
    hint: '该步骤失败后立即终止整个任务，后续条目不再执行',
  },
  {
    value: STEP_FAILURE_POLICY_SKIP,
    label: '跳过该条目',
    hint: '仅跳过当前失败的条目，继续执行后续条目',
  },
];

/** 默认策略：终止整批 */
export function normalizeStepFailurePolicy(value) {
  return String(value ?? '').trim().toLowerCase() === STEP_FAILURE_POLICY_SKIP
    ? STEP_FAILURE_POLICY_SKIP
    : STEP_FAILURE_POLICY_ABORT;
}

export function isSkipOnFailure(value) {
  return normalizeStepFailurePolicy(value) === STEP_FAILURE_POLICY_SKIP;
}
